export default {
  state: {
    countries: [],
    loading: false,
  },
  getters: {
    countries: state => state.countries,
    loading: state => state.loading,
  },
  mutations: {
    setCountries(state, countries) {
      state.countries = countries;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const countries = await axios.get('api/countries');
        commit('setCountries', countries);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/countries/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
      await axios.post('api/countries', payLoad);
    },

    async update({ commit }, payLoad) {
      await axios.put('api/countries', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/countries/' + id);
    }
  },
};
